import { date } from 'quasar'
import Model, { ID, Integer, IsoDateTime, MODEL_LEVEL } from 'src/models/model'

// Hour that defines the beginning and end of a day. This allows showtimes that start after midnight
// to be logically grouped with the prior day
export const START_HOUR = 4

// Accepts a Date object or DateTime string
function toTimeString (time) {
  if (_.isDate(time) || (_.isString(time) && time.length > 5)) {
    return date.formatDate(time, 'HH:mm')
  } else {
    return time
  }
}

export function timeToMinutes (time) {
  time = toTimeString(time)
  let hours = +time.split(':')[0] - START_HOUR
  if (hours < 0) {
    hours += 24
  }
  return hours * 60 + (+time.split(':')[1])
}

export default class TimeSlot extends Model {
  static name = 'TimeSlot'

  static isConfiguration = true

  static deletable = true

  static versioned = true

  static level = MODEL_LEVEL.SITE

  static employeeRequiredPermissionCategories = [Model.permissionCategories.Site, Model.permissionCategories.FilmProgramming]

  static define () {
    this.fields = {
      id: {
        type: ID,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      shortName: {
        type: String,
        required: true
      },
      displayOrder: {
        type: Integer,
        default: 100
      },
      startTime: { // TODO rename to rangeStartTime
        type: String
      },
      endTime: { // TODO rename to rangeEndTime
        type: String
      },
      targetTime: {
        type: String
      }
    }

    this.computed = {
      displayName () {
        const dateTime = new IsoDateTime()

        dateTime.setSeconds(0)
        dateTime.setMinutes(0)
        dateTime.setHours(0)

        const startTimeFormatted = this.i18n.d(date.addToDate(dateTime, { minutes: 240 + timeToMinutes(this.startTime) }), 'shortTime')
        const endTimeFormatted = this.i18n.d(date.addToDate(dateTime, { minutes: 240 + timeToMinutes(this.endTime) }), 'shortTime')

        return `${this.name} (${startTimeFormatted} - ${endTimeFormatted})`
      }
    }
  }

  get startTimeMinutes () {
    return timeToMinutes(this.startTime)
  }

  get endTimeMinutes () {
    return timeToMinutes(this.endTime)
  }

  static timeSlotForDateTime (dateTime) {
    const time = toTimeString(dateTime)
    const minutes = timeToMinutes(time)

    return _.find(this.configuration.timeSlots.data, timeSlot => timeSlot.startTimeMinutes <= minutes && minutes < timeSlot.endTimeMinutes)
  }
}
